"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledIcon = styled_components_1.default.i `
  color: ${({ white }) => (white ? config_1.colors.white : config_1.colors.thundercloud)};
  font-size: ${({ size }) => (size ? size : '16px')};
  margin-right: ${({ margin }) => (margin ? margin : '0')};
`;
